__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-02-1788348595-stable-dev/";